const lastVisitedPage = ref();

export const useLastVisitedPage = () => {
  const addPage = (path: string) => {
    lastVisitedPage.value = path;
  };

  return {
    addPage,
    lastVisitedPage,
  };
};
